import moment from 'moment-timezone'

export const getDate = (date) => {
  if (typeof date === 'string') date = moment(date)
  const year = appendZero(date.year().toString())
  const month = appendZero((date.month() + 1).toString())
  const day = appendZero(date.date().toString())
  return `${year}-${month}-${day}`
}

export const getDateFullTime = (date) => {
  if (typeof date === 'string') date = moment(date)
  const hours = appendZero(date.hour().toString())
  const minutes = appendZero(date.minutes().toString())
  const seconds = appendZero(date.seconds().toString())
  return `${hours}:${minutes}:${seconds}`
}

export const convertTZ = (date, timeZone = 'UTC') => {
  return moment.tz(date, timeZone)
}

const appendZero = (value) => {
  if (value.length === 1) value = '0' + value
  return value
}
